var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsAccountsettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.169,
    height: 47.169,
    viewBox: "0 0 47.169 47.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-svgrepo-com_1_",
    "data-name": "settings-svgrepo-com (1)",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55067",
    "data-name": "Path 55067",
    d: "M43.318,17.76H39.045a1.64,1.64,0,0,1-1.16-2.8l3.021-3.02a2.353,2.353,0,0,0,0-3.326L37.055,4.763a2.408,2.408,0,0,0-3.326,0l-3.02,3.02a1.64,1.64,0,0,1-2.8-1.159V2.351A2.354,2.354,0,0,0,25.558,0H20.111A2.354,2.354,0,0,0,17.76,2.351V6.624a1.64,1.64,0,0,1-2.8,1.159l-3.02-3.02a2.408,2.408,0,0,0-3.326,0L4.763,8.614a2.353,2.353,0,0,0,0,3.326l3.021,3.02a1.64,1.64,0,0,1-1.16,2.8H2.351A2.354,2.354,0,0,0,0,20.111v5.446a2.354,2.354,0,0,0,2.351,2.352H6.624a1.64,1.64,0,0,1,1.16,2.8l-3.021,3.02a2.353,2.353,0,0,0,0,3.326l3.851,3.851a2.406,2.406,0,0,0,3.326,0l3.02-3.021a1.64,1.64,0,0,1,2.8,1.16v4.273a2.354,2.354,0,0,0,2.351,2.351h5.446a2.354,2.354,0,0,0,2.351-2.351V39.045a1.64,1.64,0,0,1,2.8-1.16l3.02,3.021a2.408,2.408,0,0,0,3.326,0l3.851-3.851a2.353,2.353,0,0,0,0-3.326l-3.021-3.02a1.64,1.64,0,0,1,1.161-2.8h4.273a2.354,2.354,0,0,0,2.351-2.351V20.111A2.354,2.354,0,0,0,43.318,17.76Zm.66,7.8a.661.661,0,0,1-.66.66H39.045a3.332,3.332,0,0,0-2.356,5.688l3.021,3.02a.66.66,0,0,1,0,.934L35.859,39.71a.66.66,0,0,1-.934,0l-3.02-3.021a3.332,3.332,0,0,0-5.688,2.356v4.273a.661.661,0,0,1-.66.66H20.111a.661.661,0,0,1-.66-.66V39.045a3.28,3.28,0,0,0-2.057-3.078,3.37,3.37,0,0,0-1.3-.263,3.286,3.286,0,0,0-2.335.984l-3.02,3.021a.66.66,0,0,1-.934,0L5.959,35.859a.66.66,0,0,1,0-.934L8.98,31.9a3.331,3.331,0,0,0-2.356-5.687H2.351a.661.661,0,0,1-.66-.66V20.111a.661.661,0,0,1,.66-.66H6.624A3.332,3.332,0,0,0,8.98,13.763l-3.021-3.02a.66.66,0,0,1,0-.934L9.81,5.959a.66.66,0,0,1,.934,0l3.02,3.02a3.332,3.332,0,0,0,5.688-2.355V2.351a.661.661,0,0,1,.66-.66h5.446a.661.661,0,0,1,.661.66V6.624A3.332,3.332,0,0,0,31.906,8.98l3.02-3.02a.66.66,0,0,1,.934,0L39.71,9.81a.66.66,0,0,1,0,.934l-3.021,3.02a3.332,3.332,0,0,0,2.356,5.688h4.273a.659.659,0,0,1,.66.659Z",
    fill: "#387f75",
    stroke: "#387f75",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55068",
    "data-name": "Path 55068",
    d: "M25.611,18a7.611,7.611,0,1,0,7.612,7.611A7.62,7.62,0,0,0,25.611,18Zm0,13.532a5.92,5.92,0,1,1,5.92-5.92A5.928,5.928,0,0,1,25.611,31.532Z",
    transform: "translate(-2.777 -2.777)",
    fill: "#387f75",
    stroke: "#387f75",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsAccountsettings);
export default __webpack_public_path__ + "static/media/settings-accountsettings.d006fef772e293f3a69d0770a974dbfd.svg";
export { ForwardRef as ReactComponent };